import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';


import { addDefaultImageSrc } from '../common/utilities/utilities';
import EmojiRating from './EmojiRating';
import { roundedOverallRatingScore } from '../common/utilities/ratings';

const ServiceProvidersListItem = (props, context) => {
  const {
    rating, comments_count, rating_count, name, image, id, lang, name_en, countries, categories
  } = props;

  return (
    <Link to={`/services/${id}`}>
      <div className='Card mt-3' style={{ textAlign: 'center' }}>
        <div style={{ position: 'relative' }}>
          <Image
            src={image || '/static/media/service.png'}
            crossOrigin='anonymous'
            style={{
              width: '100%',
              height: '120px',
              objectFit: 'contain',
              border: 'solid 1px grey'
            }}
            onError={addDefaultImageSrc}
          />
          <div className='comments-counter'>
            <i className='far fa-comment-alt'></i>
            <span> {comments_count} </span>
          </div>
        </div>
        <div className='rating-overall-row'>
          <EmojiRating score={roundedOverallRatingScore(rating)} interactive={false} small />
          <span>{rating && rating.toFixed(1)}
            <span
              style={{ position: 'relative', bottom: '7px', fontSize: '0.7em' }}
            >
              {' '}
              ({rating_count})
            </span>
          </span>
        </div>

        <h3 className='ListItemName'> {name} </h3>
        {lang == 'ne' || lang == 'en' ? null : (
          <h3 className='ListItemName'> {name_en} </h3>
        )}
        <div>
          <p style={{ marginBottom: 0 }} className='mt-1'>
            {' '}
            {countries}{' '}
          </p>
          <div style={{ fontWeight: 600 }}>
            {categories.length > 2 ? (
              <div>
                <p style={{ marginBottom: 0 }}>
                  {' '}
                  {categories.slice(0, 2).join(', ')}{' '}
                </p>
                <p>
                  {' '}
                  {`+ ${categories.length - 2} ${context.t('more')}`}{' '}
                </p>
              </div>
            ) : (
              <p> {categories.join(', ')} </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

ServiceProvidersListItem.contextTypes = {
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang
});

export default connect(mapStateToProps)(ServiceProvidersListItem);
